const snack = require("../../../../../components/snack/snack");
const inventoryReportAvailable = require("../inventory/inventory-report-item-available");

const showError = (id = "downloadError") => snack.start({ act: "show", id });

function hubDetail() {
  return {
    reportPageRightId: "reportHub-report-output",
    skipReportPage: true,
    entity: "inventory",
  };
}

export function getData(def, filters) {
  const actions = {
    "inventory-items-available": () => {
      inventoryReportAvailable.start({
        ...hubDetail(),
        source: "hub",
      });
    },
  };

  const action = actions[def.id];
  action ? action() : showError();
}
